import { HorizontalBar } from "vue-chartjs";
import "chartjs-plugin-datalabels";

export default {
  extends: HorizontalBar,
  props: {
    color: String,
    valores: Object,
    label: String,
    offset: {
      type: Number,
      default: -20
    },
    font: {
      type: Number,
      default: 12
    },
    suffix: {
      type: String,
      default: ""
    }
  },
  data: function() {
    return {
      datacollection: {
        labels: this.valores.labels,
        datasets: [
          {
            barPercentage: 0.6,
            backgroundColor: this.color,
            pointBackgroundColor: "white",
            borderWidth: 1,
            pointBorderColor: "#249EBF",
            data: this.valores.valores
          }
        ]
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontColor: "#f0f0f0",
                fontSize: this.font,
                mirror: true,
                labelOffset: (this.offset * window.innerHeight) / 625 - 2,
                callback: function(value) {
                  return value.substring(0, Math.min(value.length, 40));
                }
              },
              gridLines: {
                display: false
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontColor: "#f0f0f0",
                fontSize: 0
              },
              gridLines: {
                display: false
              }
            }
          ]
        },
        legend: {
          display: false
        },
        tooltips: {
          enabled: false
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            align: "end",
            anchor: "start",
            color: "#f0f0f0",
            font: {
              size: "14"
            },
            formatter: this.format
          }
        }
      }
    };
  },
  methods: {
    format(value) {
      return value.toFixed(2).replace(".", ",") + this.suffix;
    }
  },
  mounted() {
    // this.chartData is created in the mixin
    this.renderChart(this.datacollection, this.options);
  }
};
